/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Space,
  Text,
  Popup,
} from '@cashfree-intl/coherent';

import useClickOutside from 'utils/hooks';
import CustomIcon from 'components/CustomIcons';
import { PAYMENT_METHODS_ICON_MAPPER } from '../constants';

const getIcon = obj => {
  const IconComponent = () => (
    <CustomIcon
      componentName={PAYMENT_METHODS_ICON_MAPPER[obj.nick]}
      key={obj.nick}
    />
  );

  return PAYMENT_METHODS_ICON_MAPPER[obj.nick] ? (
    <Popup
      key={obj.code}
      content={obj.display}
      trigger={
        <span className="icon" key={obj.nick}>
          <IconComponent />
        </span>
      }
    />
  ) : null;
};

const renderModeHistory = modes => (
  <div className="payment-method-history-grid">
    {Object.keys(modes).map((paymentGroup, outerIndex) =>
      modes[paymentGroup].map((obj, innerIndex) => (
        <>
          <div
            key={obj.code}
            className={`row ${
              outerIndex + 1 === Object.keys(modes).length &&
              innerIndex + 1 === modes[paymentGroup].length
                ? 'last-row'
                : ''
            }`}
          >
            <div>{getIcon(obj)}</div>
            <Text variant="b14" className="text-center">
              {obj.remark}
            </Text>
            <Text variant="b14" color="bodyLight" className="text-right">
              {moment(obj.date).format('MMM DD, YYYY')}
            </Text>
          </div>
          <div className="vertical-divider" />
        </>
      )),
    )}
  </div>
);

const PaymentMethodHistory = ({ closeModal, rejectedModes }) => {
  const modalRef = useRef(null);
  useClickOutside(modalRef, closeModal);

  return (
    <Modal className="payment-method-history-modal" open ref={modalRef}>
      <ModalHeader>
        <Space
          justifyContent="space-between"
          alignItems="center"
          className="full-width"
        >
          <Text variant="h20">History</Text>
          <div
            className="close-modal"
            data-event-name="PaymentMethodHistoryModal_Icon_Close"
            data-ignore-inner-text="true"
            onClick={closeModal}
          >
            <CustomIcon componentName="CLOSE" />
          </div>
        </Space>
      </ModalHeader>
      <ModalContent>
        <Space direction="column" gap={3}>
          <Text variant="b14" color="bodyLight">
            Activated payment modes are shown in the Active Modes column.
            Rejected payment modes are shown below. Please write to{' '}
            <a href="mailto:care@cashfree.com">care@cashfree.com</a> for further
            assistance.
          </Text>
          {/* {JSON.stringify(rejectedModes)} */}
          {renderModeHistory(rejectedModes)}
        </Space>
      </ModalContent>
    </Modal>
  );
};

PaymentMethodHistory.propTypes = {
  closeModal: PropTypes.func.isRequired,
  rejectedModes: PropTypes.object,
};

export default PaymentMethodHistory;
